import { render, staticRenderFns } from "./DashboardStatisticChartFilters.vue?vue&type=template&id=3dfe322e&scoped=true"
import script from "./DashboardStatisticChartFilters.vue?vue&type=script&lang=js"
export * from "./DashboardStatisticChartFilters.vue?vue&type=script&lang=js"
import style0 from "./DashboardStatisticChartFilters.vue?vue&type=style&index=0&id=3dfe322e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfe322e",
  null
  
)

export default component.exports